module.exports = __webpack_public_path__ + "static/media/Obesity.17d010fc.png";